var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adData.img)?_c('div',{staticClass:"banner-ad",on:{"click":_vm.handleClickBanner}},[_c('img',{attrs:{"src":_vm.adData.img,"alt":"互动广告"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }